import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=cb3f8e7c&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=cb3f8e7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3f8e7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb3f8e7c')) {
      api.createRecord('cb3f8e7c', component.options)
    } else {
      api.reload('cb3f8e7c', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=cb3f8e7c&scoped=true&", function () {
      api.rerender('cb3f8e7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dXnwG13M0xhJ/JS/comp/SearchFilterTokens.vue"
export default component.exports